import { AxiosInstance } from 'axios'
import { Note } from '@dc-shared-web/hooks/api/comparison/types'

interface CreateChangeNoteParams {
  content: string
  created_by: string
}

export const createChangeNote = async (
  apiClient: AxiosInstance,
  changeUuid: string,
  params: CreateChangeNoteParams
): Promise<Note> => {
  const response = await apiClient.post(`/v1/notes/${changeUuid}`, params)
  return response.data
}
